/* eslint-disable max-len */
import { useEffect, useRef, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import SignatureCanvas from 'react-signature-canvas';

import { Link } from 'react-router-dom';
import Button from '../../components/Button';
import DefaultHereMap from '../../components/DefaultHereMap';
import CaptaHeader from '../../components/Header';
import Loader from '../../components/Loader';
import MyModal from '../../components/Modal';
import NoData from '../../components/NoData';
import Textarea from '../../components/Textarea';
import Transitions from '../../components/Transition';
import { domain } from '../../enviromentVariables';
import formatCurrency from '../../utils/formatCurrency';
import AIChat from './components/AIChat';
import ConsultCard from './components/ConsultCard';
import DistanceCard from './components/DistanceCard';
import PriceCard from './components/PriceCard';
import SidebarRoute from './components/SidebarRoute';
import { IconContainer } from './components/SidebarRoute/components/Route/styles';
import Timecard from './components/TimeCard';
import {
  AcceptContainer,
  AcceptModalContainer,
  Actions,
  Container,
  Display,
  Header,
  LastComplaintContainer,
  MapContainer,
  RefuseModalContainer,
  SingatureContainer,
  TicketDescription,
  TicketGroup,
  TicketInfo,
  TicketTotal,
  Title,
  TotalContainer,
} from './styles';
import useResult from './useResult';

export default function Result() {
  const {
    isLoading,
    goingRoute,
    returningRoute,
    tickets,
    view,
    setView,
    logo,
    hasError,
    exceededPrice,
    totalPrice,
    resultStatus,
    allowPdfDownload,
    handleTryAgain,
    consultCode,
    adjustmentReason,
    handleAdjustmentReasonChange,
    setAdjustmentModalShow,
    requestAdjustment,
    adjustmentModalShow,
    isSomeActionLoading,
    setRefuseModalShow,
    acceptModalShow,
    setAcceptModalShow,
    refuseModalShow,
    handleResultAction,
    remainingAdjustmentChars,
    isRefuseButtonDisabled,
    setIsRefuseButtonDisabled,
    isAcceptButtonDisabled,
    setIsAcceptButtonDisabled,
    isBkConsultAndNotOptimized,
    canShowMap,
    isTicketsTabVisible,
    companyToRedirectMinorApprentice,
    isMinorApprentice,
    lastReclamationAndAnswer,
    aiChatHistory,
    aiModalShow,
    setAiModalShow,
    isAiLoading,
    aiStreamingText,
    aiRejectionReason,
    handleAiMessage,
    handleStreamingDone,
    handleOpenAdjustmentModal,
    setRejectionReasonModalShow,
    rejectionReasonModalShow,
  } = useResult();

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [acceptCanvas, setAcceptCanvas] = useState(null);
  const [refuseCanvas, setRefuseCanvas] = useState(null);
  const [agreedWithRefuseVt, setAgreedWithRefuseVt] = useState(false);

  const sigCanvas = useRef(null);
  const sigRefuseCanvas = useRef(null);

  const standardRender = (resultStatus === 'nothingDone' || resultStatus === 'answered') && allowPdfDownload && !exceededPrice;
  const standardRenderBlockPdf = (resultStatus === 'nothingDone' || resultStatus === 'answered') && !allowPdfDownload && !exceededPrice;

  const isImplant = resultStatus === 'accepted' || resultStatus === 'refused';
  const downloadPdfRender = isImplant && allowPdfDownload && !exceededPrice;

  const totalVt = tickets.reduce((acc, cur) => (
    acc + cur.totVt
  ), 0);

  // eslint-disable-next-line max-len
  // const anyButtonToRender = (((resultStatus === 'accepted' || resultStatus === 'refused') && !allowPdfDownload) || resultStatus === 'waitingAnswer' || exceededPrice);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Transitions>
      <Loader isLoading={isLoading || isSomeActionLoading} />
      {!hasError && !isLoading && !isBkConsultAndNotOptimized && !exceededPrice && (
        <Container>
          <SidebarRoute
            setView={setView}
            goingRoute={goingRoute}
            returningRoute={returningRoute}
            tickets={tickets}
            view={view}
            logo={logo}
            isTicketsTabVisible={isTicketsTabVisible}
          />

          <Display>
            <Header>
              <ConsultCard consultCode={consultCode} />
              <PriceCard totalPrice={totalPrice} />
              <DistanceCard walkDistance={goingRoute[0].distanciaTj} />
              <Timecard walkTime={goingRoute[0].tempoTj} />
            </Header>

            {(standardRender || standardRenderBlockPdf) && (
              <Actions>
                <Button background="#428bca" onClick={handleOpenAdjustmentModal}>
                  Solicitar Ajuste
                </Button>
                <Button background="#5cb85c" onClick={() => setAcceptModalShow(true)}>
                  Aceitar
                </Button>
                <Button background="#d9534f" onClick={() => setRefuseModalShow(true)}>
                  Não desejo VT
                </Button>
              </Actions>
            )}

            {isImplant && !isBkConsultAndNotOptimized && (
              <Actions>
                {downloadPdfRender && (
                  <a href={`https://rels${domain}/GeradorCarta?Consulta=${consultCode}`} download target="_blank" rel="noreferrer">
                    <Button background="#428bca">Baixar Carta</Button>
                  </a>
                )}
                {resultStatus === 'accepted' && (
                  <Button background="#d9534f" onClick={() => setRefuseModalShow(true)}>
                    Cancelar VT
                  </Button>
                )}
                {isMinorApprentice && (
                  <Link to={`/?codEmpresa=${companyToRedirectMinorApprentice}`}>
                    <Button background="#5cb85c">Roteirizar Curso</Button>
                  </Link>
                )}
              </Actions>
            )}
          </Display>

          <MyModal
            title="Solicitar Ajuste."
            closeButtonLabel="Cancelar"
            actionButtonLabel="Enviar Solicitação"
            modalBody={(
              <>
                {lastReclamationAndAnswer && (
                  <LastComplaintContainer>
                    <div className="complaint-header">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z" />
                      </svg>
                      Histórico da Última Solicitação
                    </div>

                    <div className="complaint-section">
                      <div className="section-label">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455zM4 18.385L5.763 17H20V5H4v13.385zM11 13h2v2h-2v-2zm0-6h2v5h-2V7z" />
                        </svg>
                        Sua Reclamação
                      </div>
                      <div className="section-content">{lastReclamationAndAnswer.reclamacao}</div>
                      <div className="section-date">
                        Enviado em:
                        {' '}
                        {lastReclamationAndAnswer.dataReclamacao}
                      </div>
                    </div>

                    <div className="complaint-section answer-section">
                      <div className="section-label">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455zM4 18.385L5.763 17H20V5H4v13.385zM11 10h2v2h-2v-2zm0-4h2v3h-2V6z" />
                        </svg>
                        Nossa Resposta
                      </div>
                      <div className="section-content">{lastReclamationAndAnswer.resposta}</div>
                      <div className="section-date">
                        Respondido em:
                        {' '}
                        {lastReclamationAndAnswer.dataResposta}
                      </div>
                    </div>
                  </LastComplaintContainer>
                )}

                {aiRejectionReason && (
                  <LastComplaintContainer>
                    <div className="complaint-header">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" />
                      </svg>
                      Tentativa de Resolução por IA
                    </div>

                    <div className="complaint-section">
                      <div className="section-label">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2.546 20.2A1 1 0 0 0 3.8 21.454l3.032-.892A9.957 9.957 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.957 7.957 0 0 1-4.243-1.213l-.264-.157-2.244.66.66-2.244-.157-.264A7.957 7.957 0 0 1 4 12a8 8 0 1 1 8 8z" />
                        </svg>
                        Motivo da Rejeição
                      </div>
                      <div className="section-content">{aiRejectionReason}</div>
                    </div>
                  </LastComplaintContainer>
                )}

                <h6>Descreva abaixo o motivo da sua solicitação de ajuste (máx. 300 caracteres)</h6>
                <Textarea
                  value={adjustmentReason}
                  placeholder="*Compartilhe sua dúvida com clareza e objetividade. Se puder, detalhe a LINHA, OPERADORA, VALOR e QUANTIDADE/DIA onde o problema acontece — e use os mesmos critérios para sugerir uma solução. Quanto mais direto, mais rápido conseguimos ajudar!"
                  onChange={handleAdjustmentReasonChange}
                />
                <small>
                  {remainingAdjustmentChars}
                  {' '}
                  Caracteres restantes
                </small>
              </>
          )}
            onClose={() => setAdjustmentModalShow(false)}
            onAction={() => requestAdjustment()}
            isActionButtonDisabled={!adjustmentReason}
            show={adjustmentModalShow}
            type="suspendAction"
          />

          <MyModal
            title="Não foi possível prosseguir com seu ajuste."
            closeButtonLabel="Fechar"
            modalBody={(
              <LastComplaintContainer>
                <div className="complaint-header">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" />
                  </svg>
                  Tentativa de Resolução por IA
                </div>

                <div className="complaint-section">
                  <div className="section-label">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2.546 20.2A1 1 0 0 0 3.8 21.454l3.032-.892A9.957 9.957 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.957 7.957 0 0 1-4.243-1.213l-.264-.157-2.244.66.66-2.244-.157-.264A7.957 7.957 0 0 1 4 12a8 8 0 1 1 8 8z" />
                    </svg>
                    Motivo da Rejeição
                  </div>
                  <div className="section-content">{aiRejectionReason}</div>
                </div>
              </LastComplaintContainer>
          )}
            onClose={() => setRejectionReasonModalShow(false)}
            show={rejectionReasonModalShow}
            type="info"
          />

          <MyModal
            title="Não optar pelo VT"
            closeButtonLabel="Cancelar"
            actionButtonLabel="Confirmar recusa do VT"
            modalBody={(
              <RefuseModalContainer>
                <strong>ATENÇÃO:</strong>
                <div>
                  Ao prosseguir, você está optando por não receber o vale-transporte.
                </div>

                <SingatureContainer>
                  <span>Assine aqui</span>
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
                    ref={sigRefuseCanvas}
                    onEnd={() => {
                      setIsRefuseButtonDisabled(false);
                      setRefuseCanvas(sigRefuseCanvas.current?.getTrimmedCanvas());
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      sigRefuseCanvas.current.clear();
                      setIsRefuseButtonDisabled(true);
                    }}
                  >
                    Refazer
                  </button>
                </SingatureContainer>

                <div>
                  <input type="checkbox" onChange={() => setAgreedWithRefuseVt((prevState) => !prevState)} checked={agreedWithRefuseVt} style={{ marginRight: '8px' }} />
                  <label htmlFor="agreedWithRefuseVt">Eu concordo que, ao prosseguir, opto por declinar o benefício do vale-transporte, portanto, não o receberei.</label>
                </div>
              </RefuseModalContainer>
          )}
            onClose={() => { setRefuseModalShow(false); setIsRefuseButtonDisabled(true); }}
            onAction={() => handleResultAction('refuse', refuseCanvas)}
            isActionButtonDisabled={isRefuseButtonDisabled || !agreedWithRefuseVt}
            show={refuseModalShow}
            type="deleteAction"
          />

          <MyModal
            title="Assine e revise seus bilhetes"
            closeButtonLabel="Cancelar"
            actionButtonLabel="Confirmar Resultado"
            size="lg"
            modalBody={(
              <AcceptModalContainer>
                <AcceptContainer>
                  {tickets.map((ticket) => (
                    <TicketGroup key={`${ticket.codOperadora}${ticket.codVT}${ticket.qtdVt}${ticket.tipoTransp}`}>
                      <IconContainer logo>
                        <img src={ticket.linkOPLogo} alt="opLogo" className="noBg" />
                      </IconContainer>

                      <TicketInfo>
                        <Title>
                          {ticket.qtdVt}
                          x
                          {' '}
                          {ticket.operadora}
                        </Title>

                        <TicketDescription>
                          {formatCurrency(ticket.tarifaVt)}
                          {' '}
                          -
                          {' '}
                          {ticket.tipoTransp}
                        </TicketDescription>

                        <TicketTotal>
                          Total de
                          {' '}
                          {formatCurrency(ticket.totVt)}
                        </TicketTotal>
                      </TicketInfo>
                    </TicketGroup>
                  ))}

                  <TotalContainer>
                    VT Total por dia
                    {' '}
                    {formatCurrency(totalVt)}
                  </TotalContainer>
                </AcceptContainer>

                <SingatureContainer>
                  <span>Assine aqui</span>
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
                    ref={sigCanvas}
                    onEnd={() => {
                      setIsAcceptButtonDisabled(false);
                      setAcceptCanvas(sigCanvas.current?.getTrimmedCanvas());
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      sigCanvas.current.clear();
                      setIsAcceptButtonDisabled(true);
                    }}
                  >
                    Refazer
                  </button>
                </SingatureContainer>

              </AcceptModalContainer>
          )}
            onClose={() => { setAcceptModalShow(false); setIsAcceptButtonDisabled(true); }}
            onAction={() => handleResultAction('accept', acceptCanvas)}
            isActionButtonDisabled={isAcceptButtonDisabled}
            show={acceptModalShow}
            type="activateAction"
          />

          <MyModal
            // title="Assistente Virtual de Ajustes"
            closeButtonLabel="Fechar"
            modalBody={(
              <AIChat
                onSendMessage={handleAiMessage}
                history={aiChatHistory}
                isLoading={isAiLoading}
                streamingText={aiStreamingText}
                onStreamingDone={handleStreamingDone}
                onClose={() => setAiModalShow(false)}
              />
            )}
            onClose={() => setAiModalShow(false)}
            show={aiModalShow}
            size="xl"
            hideActionButton
            onlyBody
          />

          <MapContainer>
            {canShowMap ? (
              <iframe
                title="Mapa"
                src={`https://mapas${domain}/home/index?consulta=${consultCode}&sentido=1&rota=1&trajeto=1&h=${height}&w=${width}&z=12`}
                width={width}
                height={height}
                marginWidth={0}
                marginHeight={0}
              />
            ) : <DefaultHereMap height={height} width={width} />}
          </MapContainer>

        </Container>
      )}

      {!hasError && !isLoading && isBkConsultAndNotOptimized && (
        <>
          <CaptaHeader />
          <NoData
            icon="ok"
            label={(
              <>
                Percebemos que o vale-transporte que utiliza atualmente não sofrerá alterações.
                Está tudo OK!
                Obrigado!
              </>
)}
          />
        </>
      )}

      {!hasError && !isLoading && exceededPrice && (
      <>
        <CaptaHeader />
        <NoData
          icon="sad"
          label={(
            <>
              Ocorreu uma inconscistência.
              Por favor, procure o RH de sua empresa para mais informações.
            </>
)}
        />
      </>
      )}

      {hasError && !isLoading && (
        <>
          <CaptaHeader />
          <NoData
            icon="sad"
            label={(
              <>
                Ocorreu um erro ao recuperar seu resultado.
                <button type="button" onClick={handleTryAgain}>Tentar Novamente</button>
              </>
)}
          />
        </>
      )}
    </Transitions>
  );
}
